import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ChildDashboardChartComponent from "../components/child/1_ChildDashboardChartComponent";
import CompareChartComponents from "../components/1_CompareChartComponents";

const ComparisonPage = () => {
  return (
    <div>
      <MasterLayout>
        {/* Breadcrumb */}
        {/* <Breadcrumb title="Home" /> */}

        <CompareChartComponents />
      </MasterLayout>
    </div>
  );
};

export default ComparisonPage;
